import * as React from 'react';

import { Outlet, createRootRoute } from '@tanstack/react-router';

import AppProvider from 'src/providers/AppProvider';
import { useAnalytics } from 'src/hooks/useAnalytics';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  // Initialize analytics tracking
  useAnalytics();

  return (
    <React.Fragment>
      <AppProvider>
        <Outlet />
      </AppProvider>
    </React.Fragment>
  );
}
